import { Schema } from "effect";
export const RetentionMessageType = Schema.Literal("text", "text_with_image", "switch_plan", "promotional_offer");
/**
 * Apple Retention Message Response Schema (RealtimeResponseBody)
 */ export class RetentionMessageResponse extends Schema.Class("RetentionMessageResponse")({
    retentionMessageId: Schema.String.pipe(Schema.nonEmptyString({
        message: ()=>"retentionMessageId is required"
    })),
    retentionMessageType: Schema.optional(RetentionMessageType),
    retentionMessageVariant: Schema.optional(Schema.String),
    customParameters: Schema.optional(Schema.Record({
        key: Schema.String,
        value: Schema.String
    }))
}) {
}
